import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";

const CARDS = [
  { key: "articles_published", label: "Публикувани статии" },
  { key: "articles_draft", label: "Чернови" },
  { key: "comments_pending", label: "Коментари за одобрение", link: "/admin/comments" },
  { key: "podcasts_total", label: "Подкаст епизоди" },
  { key: "contacts_total", label: "Контакти (Brevo)" },
];

export default function AdminDashboard() {
  const [stats, setStats] = useState(null);

  useEffect(() => {
    api.get("/admin/stats").then(({ data }) => setStats(data));
  }, []);

  return (
    <div data-testid="admin-dashboard">
      <div className="flex items-center justify-between mb-8">
        <h1 className="font-serif text-3xl font-bold text-[#1A1A1A]">Табло</h1>
        <Link to="/admin/articles/new" className="bg-[#A6192E] hover:bg-[#8C1123] text-white text-sm font-bold uppercase tracking-wide px-5 py-2.5" data-testid="admin-create-article-btn">
          + Нова статия
        </Link>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-5">
        {CARDS.map((c) => {
          const value = stats ? stats[c.key] : "...";
          const Card = (
            <div className="bg-white border border-[#E2E8F0] p-6" data-testid={`admin-stat-${c.key}`}>
              <div className="text-3xl font-serif font-bold text-[#1A1A1A]">{value}</div>
              <div className="text-sm text-[#718096] mt-1">{c.label}</div>
            </div>
          );
          return c.link ? <Link key={c.key} to={c.link}>{Card}</Link> : <div key={c.key}>{Card}</div>;
        })}
      </div>
    </div>
  );
}
